import React from 'react';
import PropTypes from 'prop-types';
import postData from '../../utilities/postData';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import CustomTd from '../shared/table/CustomTd';
import formatter from '../../utilities/formatter';

const AdAmountItem = ({
    canDelete,
    canEdit,
    deleteUrl,
    disabled,
    editItem,
    fetchData,
    item
}) => {
    function deleteItem(itemId) {
        postData(`${deleteUrl}/${itemId}`, null, fetchData);
    }

    return (
        <tr>
            <CustomTd>
                <div style={{ height: '1.9em', paddingTop: '.2em' }}>
                    {item.subLeadSourceName}
                </div>
            </CustomTd>
            <CustomTd>
                <div style={{ height: '1.9em', paddingTop: '.2em' }}>
                    {formatter.currency(item.amount)}
                </div>
            </CustomTd>
            <CustomTd className='button-cell'>
                <div style={{ height: '1.9em', paddingTop: '.2em' }}>
                    <EditDeleteButton
                        canEdit={canEdit}
                        editItem={() => editItem(item.id)}
                        canDelete={canDelete}
                        deleteItem={() => deleteItem(item.id)}
                        acl={item.acl}
                        disabled={disabled}
                    />
                </div>
            </CustomTd>
        </tr>
    );
}

AdAmountItem.defaultProps = {
    canDelete: true,
    canEdit: true
}

AdAmountItem.propTypes = {
    fetchData: PropTypes.func,
    editItem: PropTypes.func,
    deleteUrl: PropTypes.string
};

export default AdAmountItem;